package com.essntl.features.proposal.domain.model

data class ProposalFilterOptions(
    val searchText: String = "",
    val selectedProfileIds: Set<String> = emptySet(),
    val selectedProposalOrderType: Set<ProposalOrderType> = setOf(ProposalOrderType.Default),
    val selectedProposalStatus: ProposalModel.Status? = null,
    val selectedProposalsMode: Int = ProposalModes.Designer.index
)
